/**
 * @generated SignedSource<<fe682ef6a4763a908e042ab6180c14cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentTitleWithByLine_content$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2Status_content" | "ByLine_content" | "ContentTitle_content" | "MeetingNotesAutomationDiscoveryFragment_content">;
  readonly " $fragmentType": "ContentTitleWithByLine_content";
};
export type ContentTitleWithByLine_content$key = {
  readonly " $data"?: ContentTitleWithByLine_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "useNewContentTopper",
    "variableName": "useNewContentTopper"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "useNewContentTopper"
    }
  ],
  "kind": "Fragment",
  "name": "ContentTitleWithByLine_content",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "ContentTitle_content"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "ByLine_content"
    },
    {
      "kind": "FragmentSpread",
      "name": "ArchivedPageBannerV2Status_content"
    },
    {
      "kind": "FragmentSpread",
      "name": "MeetingNotesAutomationDiscoveryFragment_content"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "ca20373b83130249db590217deb6d277";

export default node;
